import ImagesSlider from 'assets/core/js/module/images-slider'

export default function (): void {
  ImagesSlider(document.querySelector<HTMLElement>('.booking__product .slider') as HTMLElement)
}
